import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';

import { updateEmployees } from 'app/state/employee/employee.actions';
import { initializingMasterDataStore } from 'app/state/master-data/master-data.actions';
import { selectMasterData } from 'app/state/master-data/master-data.selectors';

// noinspection JSUnusedGlobalSymbols
@Injectable()
export class EmployeeEffects {
    syncWithMasterDataStore$ = createEffect(() =>
        this.actions$.pipe(
            ofType(initializingMasterDataStore),
            switchMap(() => this.store.select(selectMasterData)),
            map((masterData) => updateEmployees({ employeeList: masterData?.employees ?? [] })),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
